import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

export const ContactUsForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const serviceID = "default_service";
    const templateID = "template_17e27nh";
    emailjs
      .sendForm(serviceID, templateID, form.current, "bNEXSmDnhQYO3tppu")
      .then(
        (result) => {
          alert("sent!");
        },
        (error) => {
          alert(error.text);

          console.log(error.text);
        }
      );
  };

  return (
    <form className="space-y-8 text-white" ref={form} onSubmit={sendEmail}>
      <div>
        <label className="block font-medium mb-2 text-sm ">Name</label>
        <input
          className="bg-grey  text-black text-sm  focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 "
          type="text"
          name="userName"
          placeholder="Name:"
        />
      </div>
      <div>
        <label className=" font-medium block mb-2 text-sm ">Email</label>
        <input
          className="block p-3 w-full text-sm text-black bg-grey shadow-sm focus:ring-primary-500 focus:border-primary-500"
          type="email"
          name="userEmail"
          placeholder="Email:"
        />
      </div>
      <div>
        <label className="block mb-2 font-medium text-sm ">Phone</label>
        <input
          className="block p-3  w-full text-sm text-black  bg-grey  shadow-sm focus:ring-primary-500 focus:border-primary-500"
          type="text"
          name="userPhone"
          placeholder="Phone:"
        />
      </div>
      <div className="sm:col-span-2">
        <label className="block mb-2 font-medium text-sm ">Message</label>
        <textarea
          rows="6"
          className="block p-2.5 w-full text-sm text-black bg-grey  focus:ring-primary-500 focus:border-primary-500"
          name="message"
          placeholder="Message here:"
        />
      </div>
      <div className="w-full flex justify-center">
        <button
          className="py-3 px-5 text-sm text-black text-center border border-black  bg-primary sm:w-fit hover:bg-secondary hover:text-white focus:ring-4 focus:outline-none focus:ring-primary-300"
          type="submit"
          value="Send"
        >
          Send
        </button>
      </div>
    </form>
  );
};
